import React, { useState } from 'react';
import Table from '../../components/Table';
import { Flex, theme, Flow, Link } from '@xometry/xometry_loft';
import usersApi from '../../services/users';
import { shippingServiceOptions } from '../../utils/constants';
import { Cell } from 'react-table';
import { entityTypeEnum, userRoleEnum } from '../ShippingAddress/types';
export type ShippingAccountsTableProps = {
  id?: string;
  account_number: string;
  provider: string;
  isDefault?: boolean;
  uniqueId: string;
};
const ShippingAccountTable = ({
  entityID,
  entityType,
  shippingAccounts,
  refreshAuth,
  onEditClick,
  userRole,
}: {
  entityID: string;
  entityType: string;
  shippingAccounts: ShippingAccountsTableProps[];
  refreshAuth: () => void;
  onEditClick: (index: number) => void;
  userRole: userRoleEnum | null;
}) => {
  const [isSubmitting, setIsSubmitting] = useState('');

  const removeShippingAccount = (
    accountToRemove: ShippingAccountsTableProps
  ) => {
    const { provider, account_number, uniqueId } = accountToRemove;

    setIsSubmitting(uniqueId);
    const payload = {
      shipping_account: {
        provider: provider,
        account_number: account_number,
      },
    };
    usersApi
      .postRemoveShippingAccount(entityID, payload)
      .then(() => {
        if (window.analytics) {
          window.analytics.track('Shipping Account Removed', {
            userId: entityID,
            payload,
            type: 'user',
          });
        }
        refreshAuth();
        setIsSubmitting('');
      })
      .catch((e) => {
        console.error(e);
      });
  };
  const formattedShippingAccounts = shippingAccounts.map((account, idx) => {
    const uniqueId =
      entityType === entityTypeEnum.user
        ? `${account.provider}-${account.account_number}-${idx}`
        : account.id ?? idx;
    return { ...account, id: account.id ?? idx, uniqueId };
  });
  const findShippingService = (value: string) => {
    const selectedService = shippingServiceOptions.filter(
      (option) => option.value === value
    );
    return <>{selectedService[0]?.label}</>;
  };

  const ShippingAccountColumns = () => {
    const columns = [
      {
        Header: 'Account Number',
        accessor: 'account_number',
      },
      {
        Header: 'Shipping Service',
        accessor: 'provider',
        Cell: ({ cell }: { cell: Cell<ShippingAccountsTableProps> }) => (
          <>{findShippingService(cell.value)}</>
        ),
      },
    ];

    if (entityType === entityTypeEnum.user) {
      columns.splice(2, 0, {
        Header: () => <Flex>Remove</Flex>,
        accessor: 'remove',
        Cell: ({ cell }: { cell: Cell<ShippingAccountsTableProps> }) => (
          <Flex color={theme.colors.blues[100]} style={{ cursor: 'pointer' }}>
            {isSubmitting === cell.row.original.uniqueId ? (
              <Flow scale="panel" />
            ) : (
              <i
                className="fa-regular fa-trash-can"
                onClick={() => removeShippingAccount(cell.row.original)}
              />
            )}
          </Flex>
        ),
      });
    }

    // adds Default column for teams
    if (entityType === entityTypeEnum.team) {
      columns.splice(2, 0, {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ cell }: { cell: Cell<ShippingAccountsTableProps> }) => (
          <>{cell.row.original.isDefault ? 'Default' : ''}</>
        ),
      });
      // further check if user is admin or contributor
      if (userRole !== userRoleEnum.contributor) {
        columns.splice(3, 0, {
          Header: '',
          accessor: 'edit',
          Cell: ({ cell }: { cell: Cell<ShippingAccountsTableProps> }) => (
            <Link onClick={() => onEditClick(cell.row.index)}>Edit</Link>
          ),
        });
      }
    }

    return columns;
  };

  return (
    <Table
      data={formattedShippingAccounts}
      columns={ShippingAccountColumns()}
      isReadOnly
      showPagination={false}
      loading={false}
      selectedPage={0}
      setSelectedPage={() => {}}
    />
  );
};

export default ShippingAccountTable;
